import { Box, Button, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  header?: React.ReactNode;
  title?: string;
  description?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
}

export default function ErrorComponent({
  header,
  title = 'errors.generic.title',
  description = 'errors.generic.description',
  primaryButtonText = 'common.retry',
  secondaryButtonText,
  onPrimaryAction,
  onSecondaryAction,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {header}
      <Box
        component={Paper}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        minHeight="200px"
        gap={2}
      >
        <Typography variant="h5" color="error" gutterBottom>
          {t(title)}
        </Typography>
        <Typography color="text.secondary" variant="body1" textAlign="center">
          {t(description)}
        </Typography>
        <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          {onPrimaryAction && (
            <Button
              variant="contained"
              color="primary"
              onClick={onPrimaryAction}
            >
              {t(primaryButtonText)}
            </Button>
          )}
          {secondaryButtonText && onSecondaryAction && (
            <Button
              variant="outlined"
              color="primary"
              onClick={onSecondaryAction}
            >
              {t(secondaryButtonText)}
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
}
